import "../../../assets/css/TimeRange/timeRangePopup.css";
import Button from "../../Reusables/Button/Button";
import Close from "../../../assets/icons/close.png";
import { useContext, useEffect, useMemo, useState } from "react";
import { AppContext } from "../../../Context/Context";
import PopupDatePicker from "../../Reusables/DatePicker/PopupDatePicker";
import TimePicker from "../../Reusables/TimePicker/TimePicker";
import moment from "moment";
import AlertMessage from "../../Reusables/AlertMessage/AlertMessage";
import useModalClose from "../../../hooks/useModalClose";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  setCurrentPageCount,
  setCurrentPageTimeMachineData,
  setGroupDataCount,
  setGroupDataCurrentCount,
  setIsTimeMachineDataAvailable,
  setSeekPosition,
  setTimeMachineDataAvailable,
  setTimeMachineDataFetchComplete,
  setTimeMachineLoader,
  setTimeMachineModeIsEnabled,
  setTimeMachineState,
  setTotalSeekPosition
} from "../../../store/oldTimeMachineSlice";
import {
  setHeatmapCurrentPageCount,
  setHeatmapTimeFrames,
  setHeatmapTotalPageCount,
  setIsHeatmapModeEnabled
} from "../../../store/heatmapSlice";
import { setTimeRangeType } from "../../../store/plantSlice";
import {
  setNavHeatmapLoader,
  setNavHeatmapTimeFrames
} from "../../../store/navHeatmapSlice";

const MODAL_ID = "time-range-wrapper-id";

const TimeRangePopup = () => {
  const {
    timeRangePopup,
    setTimeRangePopup,
    timeMachineTimeFrames,
    setTimeMachineTimeFrames
  } = useContext(AppContext);

  const { navQualityHeatmapIsEnabled } = useSelector(
    (state) => state.navHeatmap
  );

  const { timeRangeType } = useSelector((state) => state.plant);
  const { convertedHeatmapData } = useSelector((state) => state.heatmap);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { pathname } = useLocation();

  //Hooks
  const [timeFrame, setTimeFrame] = useState({
    fromDate: "",
    toDate: "",
    fromTime: "",
    toTime: ""
  });
  const [timeFrameValidation, setTimeFrameValidation] = useState({
    fromDate: true,
    toDate: true,
    fromTime: true,
    toTime: true
  });
  const [isTimeFrameValid, setIsTimeFrameValid] = useState(false);
  const [alertMessageType, setAlertMessageType] = useState(null);

  useEffect(() => {
    if (timeMachineTimeFrames?.fromDate !== "") {
      setTimeFrame(timeMachineTimeFrames);
    }
    clearTimeFrame();
  }, []);

  const setMinAndMaxDateRange = () => {
    let date = new Date();
    let minPastDate = getPastDate(date, 5);
    let maxPastDate = getTodayDate(date);
    timeFrame.fromDate = minPastDate;
    timeFrame.toDate = maxPastDate;
    setTimeFrame(timeFrame);
  };

  useEffect(() => {
    setMinAndMaxDateRange();
  }, []);

  const [timeFrameSelected, setTimeFrameSelected] = useState("");

  const enterTimeMachineMode = () => {
    dispatch(setTimeMachineModeIsEnabled(true));
    navigate("old-time-machine");
  };

  const enterHeatmapMode = () => {
    dispatch(setIsHeatmapModeEnabled(true));
  };

  /*
  sets nav heat map timeframe to LS & redirects to new tab 
   */
  const enterNavHeatmapMode = () => {
    if (!navQualityHeatmapIsEnabled) {
      navigate("nav-quality-heatmap");
      setAlertMessageType(null);
    }
  };

  const clearTimeFrame = () => {
    setTimeFrame({
      fromDate: "",
      toDate: "",
      fromTime: "",
      toTime: ""
    });
    setTimeFrameSelected("");
    setMinAndMaxDateRange();
    setTimeRangeMinimumDate(timeFrame.fromDate);
    setTimeRangeMaximumDate(timeFrame.toDate);
    setTimeFrame((data) => ({ ...data, fromTime: "", toTime: "" }));
    setTimeFrameValidation((timeFrameValidation) => ({
      ...timeFrameValidation,
      fromTime: true,
      toTime: true,
      fromDate: true,
      toDate: true
    }));
    setIsTimeFrameValid(true);
    setAlertMessageType(null);
  };

  useEffect(() => {
    if (convertedHeatmapData == null) {
      clearTimeFrame();
    }
  }, [convertedHeatmapData]);

  const resetAlertMessage = () => {
    setTimeout(() => {
      setAlertMessageType(null);
    }, 30000);
  };

  const getTimeRangeTypeBasedOnCurrentPage = () => {
    const type = pathname.includes("nav-quality-heatmap")
      ? "navHeatmap"
      : pathname.includes("old-time-machine")
      ? "timeMachine"
      : "";

    dispatch(setTimeRangeType(type));
    return type;
  };

  const applyTimeFrame = () => {
    let modalType = timeRangeType;
    if (!modalType) {
      modalType = getTimeRangeTypeBasedOnCurrentPage();
    }
    setValidateTimeFrame();
    switch (modalType) {
      case "timeMachine":
        if (validateTimeFrames()) {
          setTimeMachineTimeFrames(timeFrame);
          setTimeRangePopup(!timeRangePopup);
          enterTimeMachineMode();
          dispatch(setIsTimeMachineDataAvailable(true));
          dispatch(setTimeMachineDataAvailable(true));
          dispatch(setSeekPosition(0));
          dispatch(setTotalSeekPosition(1));
          dispatch(
            setCurrentPageTimeMachineData({ pageSize: 0, data: ["startData"] })
          );

          dispatch(setCurrentPageCount(1));
          dispatch(setGroupDataCount(0));
          dispatch(setGroupDataCurrentCount(0));
          dispatch(setTimeMachineDataFetchComplete(false));
          dispatch(setTimeMachineLoader(true));
          closeTimeRangePopup();
          dispatch(setTimeMachineState(true));
        } else {
          setTimeFrameValidation((timeFrameValidation) => ({
            ...timeFrameValidation,
            fromTime: false
          }));
          setIsTimeFrameValid(false);
          setAlertMessageType("warning");
          resetAlertMessage();
        }
        break;
      case "heatmap":
        if (validateTimeFrames()) {
          dispatch(setHeatmapTimeFrames(timeFrame));
          setTimeRangePopup(!timeRangePopup);
          dispatch(setHeatmapTotalPageCount(0));
          dispatch(setHeatmapCurrentPageCount(1));
          enterHeatmapMode();
          closeTimeRangePopup();
        } else {
          setTimeFrameValidation((timeFrameValidation) => ({
            ...timeFrameValidation,
            fromTime: false
          }));
          setIsTimeFrameValid(false);
          setAlertMessageType("warning");
          resetAlertMessage();
        }
        break;
      case "navHeatmap":
        if (validateTimeFrames()) {
          dispatch(setNavHeatmapTimeFrames(timeFrame));
          setTimeRangePopup(!timeRangePopup);
          dispatch(setNavHeatmapLoader(true));
          enterNavHeatmapMode();
          closeTimeRangePopup();
        } else {
          if (!validateToTimeRange(timeFrame)) {
            setTimeFrameValidation((timeFrameValidation) => ({
              ...timeFrameValidation,
              fromTime: false,
              toTime: false
            }));
            setIsTimeFrameValid(false);
            setAlertMessageType("ahead");
            resetAlertMessage();
          } else {
            setTimeFrameValidation((timeFrameValidation) => ({
              ...timeFrameValidation,
              fromTime: false
            }));
            setIsTimeFrameValid(false);
            setAlertMessageType("warning");
            resetAlertMessage();
          }
        }
        break;
      default:
        break;
    }
  };

  const validateToTimeRange = (timeFrame) => {
    const currentDateTime = moment();
    const { toTime, fromTime, toDate, fromDate } = timeFrame;
    const fromDateTime = moment(`${fromDate} ${fromTime}`, "YYYY-MM-DD HH:mm");
    const toDateTime = moment(`${toDate} ${toTime}`, "YYYY-MM-DD HH:mm");

    const isToTimeValid = toDateTime.isSameOrBefore(currentDateTime);
    const isRangeValid = fromDateTime.isSameOrBefore(toDateTime);

    return isToTimeValid && isRangeValid;
  };

  const validateTimeFrames = () => {
    const { fromDate, toDate, fromTime, toTime } = timeFrame;
    return !!(
      fromDate &&
      toDate &&
      fromTime &&
      toTime &&
      validateToTimeRange(timeFrame)
    );
  };

  const setValidateTimeFrame = () => {
    if (timeFrame.fromDate == "" || timeFrame.fromDate == undefined) {
      setTimeFrameValidation((validation) => ({
        ...validation,
        fromDate: false
      }));
    } else {
      setTimeFrameValidation((validation) => ({
        ...validation,
        fromDate: true
      }));
    }
    if (timeFrame.toDate == "" || timeFrame.toDate == undefined) {
      setTimeFrameValidation((validation) => ({
        ...validation,
        toDate: false
      }));
    } else {
      setTimeFrameValidation((validation) => ({ ...validation, toDate: true }));
    }
    if (timeFrame.fromTime == "" || timeFrame.fromTime == undefined) {
      setTimeFrameValidation((validation) => ({
        ...validation,
        fromTime: false
      }));
    } else {
      setTimeFrameValidation((validation) => ({
        ...validation,
        fromTime: true
      }));
    }
    if (timeFrame.toTime == "" || timeFrame.toTime == undefined) {
      setTimeFrameValidation((validation) => ({
        ...validation,
        toTime: false
      }));
    } else {
      setTimeFrameValidation((validation) => ({ ...validation, toTime: true }));
    }
  };

  const getTodayDate = (date) => {
    return new Date(date).toISOString().split("T")[0];
  };

  const getPastDate = (date, pastDateCount) => {
    let todayDate = new Date(date);
    return new Date(todayDate.setDate(todayDate.getDate() + 1 - pastDateCount))
      .toISOString()
      .split("T")[0];
  };

  const getEarlierMin = (date, timeEarlier) => {
    let newDate = moment().subtract(timeEarlier, "m")._d;
    let pastTime = String(newDate).split(" ")[4];
    let pastHour = pastTime.split(":")[0];
    let pastMinute = pastTime.split(":")[1];
    return `${pastHour}:${pastMinute}`;
  };

  const getEarlierHr = (date, timeEarlier) => {
    let newDate = moment().subtract(timeEarlier, "h")._d;
    let pastTime = String(newDate).split(" ")[4];
    let pastHour = pastTime.split(":")[0];
    let pastMinute = pastTime.split(":")[1];
    return `${pastHour}:${pastMinute}`;
  };

  const getCurrentTime = (date) => {
    let currentHour = String(date.getHours()).padStart(2, "0");
    let currentMinute = String(date.getMinutes()).padStart(2, "0");
    return `${currentHour}:${currentMinute}`;
  };

  const set15MinsTimeFrame = () => {
    let date = new Date();
    let dateToday = getTodayDate(date);

    let timeToday = getCurrentTime(date);
    setTimeFrame((date) => ({
      ...date,
      fromDate: dateToday,
      toTime: timeToday
    }));

    let earlierTime = getEarlierMin(date, 15);
    setTimeFrame((date) => ({
      ...date,
      toDate: dateToday,
      fromTime: earlierTime
    }));
    setTimeFrameSelected("15");
  };

  const set30MinsTimeFrame = () => {
    let date = new Date();
    let dateToday = getTodayDate(date);

    // let timeToday = getCurrentTime(date);
    let altered15MinsFromCurrentTime = getEarlierMin(date, 15);
    setTimeFrame((date) => ({
      ...date,
      fromDate: dateToday,
      toTime: altered15MinsFromCurrentTime
    }));

    let earlierTime = getEarlierMin(date, 45);
    setTimeFrame((date) => ({
      ...date,
      toDate: dateToday,
      fromTime: earlierTime
    }));
    setTimeFrameSelected("30");
    setIsTimeFrameValid(false);
    setAlertMessageType("altered");
    resetAlertMessage();
  };
  const set1hrTimeFrame = () => {
    let date = new Date();
    let dateToday = getTodayDate(date);

    // let timeToday = getCurrentTime(date);
    let altered15MinsFromCurrentTime = getEarlierMin(date, 15);

    setTimeFrame((date) => ({
      ...date,
      fromDate: dateToday,
      toTime: altered15MinsFromCurrentTime
    }));

    let earlierTime = getEarlierHr(date, 1.25);
    setTimeFrame((date) => ({
      ...date,
      toDate: dateToday,
      fromTime: earlierTime
    }));
    setTimeFrameSelected("1");

    setIsTimeFrameValid(false);
    setAlertMessageType("altered");
    resetAlertMessage();
  };

  const set3hrTimeFrame = () => {
    let date = new Date();
    let dateToday = getTodayDate(date);

    // let timeToday = getCurrentTime(date);
    let altered15MinsFromCurrentTime = getEarlierMin(date, 15);
    setTimeFrame((date) => ({
      ...date,
      fromDate: dateToday,
      toTime: altered15MinsFromCurrentTime
    }));

    let earlierTime = getEarlierHr(date, 3.25);
    setTimeFrame((date) => ({
      ...date,
      toDate: dateToday,
      fromTime: earlierTime
    }));
    setTimeFrameSelected("3");

    setIsTimeFrameValid(false);
    setAlertMessageType("altered");
    resetAlertMessage();
  };

  const setTodayTimeFrame = () => {
    let date = new Date();

    let dateToday = getTodayDate(date);
    // let timeToday = getCurrentTime(date);
    let altered15MinsFromCurrentTime = getEarlierMin(date, 15);

    setTimeFrame((data) => ({
      ...data,
      fromDate: dateToday,
      fromTime: "00:00",
      toTime: altered15MinsFromCurrentTime,
      toDate: dateToday
    }));
    setTimeFrameSelected("today");

    setIsTimeFrameValid(false);
    setAlertMessageType("altered");
    resetAlertMessage();
  };

  const [timeRangeMinimumDate, setTimeRangeMinimumDate] = useState("");
  const [timeRangeMaximumDate, setTimeRangeMaximumDate] = useState("");

  const closeTimeRangePopup = () => {
    setTimeRangePopup(false);

    setTimeFrameSelected("");
    setTimeRangeMinimumDate(timeFrame.fromDate);
    setTimeRangeMaximumDate(timeFrame.toDate);
    setTimeFrame((data) => ({ ...data, fromTime: "", toTime: "" }));
    setTimeFrameValidation((timeFrameValidation) => ({
      ...timeFrameValidation,
      fromTime: true,
      toTime: true,
      fromDate: true,
      toDate: true
    }));
    setIsTimeFrameValid(true);
    setAlertMessageType(null);
  };

  const getCurrentFeature = () => timeRangeType === "navHeatmap";

  useEffect(() => {
    if (timeFrame.fromDate !== "") {
      setTimeRangeMinimumDate(timeFrame.fromDate);
    }
    if (timeFrame.toDate !== "") {
      setTimeRangeMaximumDate(timeFrame.toDate);
    }

    if (
      timeFrame.fromDate &&
      timeFrame.toDate &&
      timeFrame.fromTime &&
      timeFrame.toTime
    ) {
      if (getCurrentFeature()) {
        const fromDateTime = moment(
          `${timeFrame.fromDate} ${timeFrame.fromTime}`,
          "YYYY-MM-DD HH:mm"
        );
        const toDateTime = moment(
          `${timeFrame.toDate} ${timeFrame.toTime}`,
          "YYYY-MM-DD HH:mm"
        );

        const durationInMinutes = Math.floor(
          toDateTime.diff(fromDateTime, "minutes")
        );
        const durationInHours = Math.floor(
          toDateTime.diff(fromDateTime, "hours", true)
        );
        if (durationInHours > 6) {
          setAlertMessageType("restricted");
          resetAlertMessage();
          setIsTimeFrameValid(true);
        } else if (durationInHours < 0 || durationInMinutes < 30) {
          setIsTimeFrameValid(true);
          setAlertMessageType("warning");
          resetAlertMessage();
          setTimeFrameValidation((timeFrameValidation) => ({
            ...timeFrameValidation,
            fromTime: false,
            toTime: false
          }));
        } else {
          setIsTimeFrameValid(false);
        }
      } else {
        if (!validateToTimeRange(timeFrame)) {
          setIsTimeFrameValid(true);
        } else {
          setIsTimeFrameValid(false);
        }
      }
    }
  }, [
    timeFrame.fromDate,
    timeFrame.toDate,
    timeFrame.fromTime,
    timeFrame.toTime,
    isTimeFrameValid
  ]);

  const renderAlertMessage = useMemo(() => {
    if (alertMessageType !== null) {
      let alertProps = {
        heading: "Time Range Invalid",
        description: "",
        type: "warning"
      };
      switch (alertMessageType) {
        case "warning":
          alertProps.description = "Time Range must be greater than 15 mins";
          break;
        case "restricted":
          alertProps.description = "Time Range is only available for 6 hours";
          break;
        case "ahead":
          alertProps.description =
            "Time Range entered is ahead of the current time";
          break;
        default: {
          alertProps = null;
        }
      }
      return (
        alertProps && (
          <AlertMessage
            heading={alertProps.heading}
            description={alertProps.description}
            type={alertProps.type}
            setAlertMessageType={setAlertMessageType}
          />
        )
      );
    }
  }, [alertMessageType]);

  useModalClose(MODAL_ID, () => closeTimeRangePopup());

  return timeRangePopup ? (
    <div id={MODAL_ID} className="time-range-wrapper">
      <div className="time-range-container">
        <div className="time-range-top-section">
          <p>Time Range</p>
          <img
            onClick={() => closeTimeRangePopup()}
            className="time-range-popup-close-btn"
            src={Close}
            alt="close_icon"
          />
        </div>
        <div className="time-range-middle-section">
          <div className="picker-section">
            <div className="time-range-left-panel">
              From
              <div className="time-range-pickers">
                <PopupDatePicker
                  validation={timeFrameValidation.fromDate}
                  date={timeFrame.fromDate}
                  getDate={setTimeFrame}
                  name="fromDate"
                  min={timeRangeMinimumDate}
                  max={timeRangeMaximumDate}
                />
                <TimePicker
                  validation={timeFrameValidation.fromTime}
                  time={timeFrame.fromTime}
                  getTime={setTimeFrame}
                  name="fromTime"
                />
              </div>
            </div>
            <div className="time-range-right-panel">
              To
              <div className="time-range-pickers">
                <PopupDatePicker
                  validation={timeFrameValidation.toDate}
                  date={timeFrame.toDate}
                  getDate={setTimeFrame}
                  name="toDate"
                  min={timeRangeMinimumDate}
                  max={timeRangeMaximumDate}
                />
                <TimePicker
                  validation={timeFrameValidation.toTime}
                  time={timeFrame.toTime}
                  getTime={setTimeFrame}
                  name="toTime"
                />
              </div>
            </div>
          </div>
          <div className="time-range-info">
            <p>Please enter the time as per your system time format.</p>
          </div>
          <div className="time-frame-section">
            {/* <Button
              onClick={() => set15MinsTimeFrame()}
              placeholder="Last 15 mins"
              btnClass={`time-frame-btn ${
                timeFrameSelected == "15" ? "time-frame-btn-selected" : ""
              }`}
            ></Button> */}
            <Button
              onClick={() => set30MinsTimeFrame()}
              placeholder="Last 30 mins"
              btnClass={`time-frame-btn ${
                timeFrameSelected == "30" ? "time-frame-btn-selected" : ""
              }`}
            ></Button>
            <Button
              onClick={() => set1hrTimeFrame()}
              placeholder="Last 1 hr"
              btnClass={`time-frame-btn ${
                timeFrameSelected == "1" ? "time-frame-btn-selected" : ""
              }`}
            ></Button>
            <Button
              onClick={() => set3hrTimeFrame()}
              placeholder="Last 3 hr"
              btnClass={`time-frame-btn ${
                timeFrameSelected == "3" ? "time-frame-btn-selected" : ""
              }`}
            ></Button>
            <Button
              onClick={() => setTodayTimeFrame()}
              placeholder="Today"
              btnClass={`time-frame-btn ${
                timeFrameSelected == "today" ? "time-frame-btn-selected" : ""
              }`}
            ></Button>
          </div>
          {timeFrameSelected && (
            <div className="time-range-info">
              <p className="minutes-altered-info">
                Time Range is altered since last 15 mins data is not available
              </p>
            </div>
          )}
        </div>
        <div className="time-range-bottom-section">
          <Button
            onClick={() => clearTimeFrame()}
            placeholder="Reset"
            btnClass="time-range-discard-btn time-range-btn"
          ></Button>
          <Button
            onClick={() => applyTimeFrame()}
            placeholder="Apply"
            btnClass={`time-range-confirm-btn time-range-btn ${
              isTimeFrameValid ? "time-range-invalid" : ""
            }`}
            disabled={isTimeFrameValid}
          ></Button>
        </div>
        {renderAlertMessage}
      </div>
    </div>
  ) : null;
};

export default TimeRangePopup;
